/**
 * ShopSalesDashboard Container
 * --
 * 작성자 - Owen
 * 작성일 - 2025 07 11 금요일
 * 마지막 수정일 - 2025 07 11 금요일
 */
import React from 'react';
import ShopSalesDashboardPresenter from './ShopSalesDashboardPresenter';
import dayjs from 'dayjs';
import { useGetShopInformations } from 'hooks/ShopInformationHooks';
import { useGetParcelServices } from 'hooks/ParcelServiceHooks';
import { useGetRentals } from 'hooks/RentalHooks';
import { useGetShopOrders } from 'hooks/ShopOrderHooks';

const ShopSalesDashboardContainer = (props) => {
  /**
   * SECTION - Init
   */
  const SEARCH_PERIOD = 7;
  /**!SECTION - Init */

  /**
   * SECTION - Route
   */

  /**!SECTION - Route */

  /**
   * SECTION - Props
   */
  const { defaultShop = null, auth = 'ADMIN' } = props;
  /**!SECTION - Props */

  /**
   * SECTION - Route
   */

  /**!SECTION - Route */

  /**
   * SECTION - Variable
   */

  /**!SECTION - Variable */

  /**
   * SECTION - State
   */
  const [isLoading, setIsLoading] = React.useState(false);
  const [orderList, setOrderList] = React.useState({
    delivery: [],
    subscription: [],
    rental: [],
  });
  /**!SECTION - State */

  /**
   * SECTION - Query Data
   */
  // 입점업체 목록
  const { data: Shops } = useGetShopInformations(
    {
      join_tables: '["shop_information_file"]',
    },
    {
      enabled: auth === 'ADMIN' ? true : !!defaultShop,
      initialData: [],
      select: (res) => {
        const { status, data } = res;

        if (status !== 200) return [];

        const filtered = data.filter((shop) => shop.type !== 'STORE');
        return filtered;
      },
    }
  );
  // 주문목록
  const { data: ShopOrder } = useGetShopOrders(
    {
      start_date: dayjs().subtract(SEARCH_PERIOD, 'days').startOf('day').unix(),
      end_date: dayjs().endOf('day').unix(),
      ...(auth === 'ADMIN' ? {} : { shop_information_id: defaultShop }),
    },
    {
      enabled: auth === 'ADMIN' ? true : !!defaultShop,
      initialData: [],
      select: (res) => {
        const { status, data } = res;

        if (status !== 200) return [];

        return data;
      },
    }
  );
  // 배송/정기배송 주문목록
  const { data: Parcel } = useGetParcelServices(
    {
      join_tables: '["refund"]',
      start_date: dayjs().subtract(SEARCH_PERIOD, 'days').startOf('day').unix(),
      end_date: dayjs().endOf('day').unix(),
      ...(auth === 'ADMIN' ? {} : { shop_information_id: defaultShop }),
      get_type: 'PAYMENT',
    },
    {
      enabled: auth === 'ADMIN' ? true : !!defaultShop,
      initialData: [],
      select: (res) => {
        const { status, data } = res;

        if (status !== 200) return [];

        return data;
      },
    }
  );
  // 렌탈목록
  const { data: Rental } = useGetRentals(
    {
      join_tables: '["refund"]',
      start_date: dayjs().subtract(10, 'days').startOf('day').unix(),
      end_date: dayjs().endOf('day').unix(),
      ...(auth === 'ADMIN' ? {} : { shop_information_id: defaultShop }),
      get_type: 'PAYMENT',
    },
    {
      enabled: auth === 'ADMIN' ? true : !!defaultShop,
      initialData: [],
      select: (res) => {
        const { status, data } = res;

        if (status !== 200) return [];

        return data;
      },
    }
  );
  /**!SECTION - Query Data */

  /**
   * SECTION - Mutate
   */

  /**!SECTION - Mutate */

  /**
   * SECTION - Function
   */
  /**
   * 주문 데이터 정제
   * --
   */
  const getOrderData = React.useCallback(() => {
    if (!defaultShop && auth !== 'ADMIN') return;

    setIsLoading(true);

    const newData = Parcel.reduce(
      (acc, cur) => {
        const { type } = cur;

        if (type === 'SUBSCRIPTION') {
          acc['subscription'].push(cur);
        } else {
          acc['delivery'].push(cur);
        }

        return acc;
      },
      {
        delivery: [],
        subscription: [],
        rental: Rental,
      }
    );

    setTimeout(() => {
      setIsLoading(false);
      setOrderList(newData);
    }, 1000);
  }, [Rental, Parcel, defaultShop, auth]);
  /**!SECTION - Function */

  /**
   * SECTION - Hooks
   */
  /**
   * 주문 데이터 정제 호출
   * --
   */
  React.useEffect(() => {
    if (auth !== 'ADMIN' && !defaultShop) return;

    getOrderData();
  }, [getOrderData, defaultShop, auth]);
  /**!SECTION - Hooks */

  /**
   * SECTION - Props
   */
  const PROPS = {
    isLoading,
    auth,
    shopInformation: Shops,
    selectedShop: defaultShop,
    orders: ShopOrder,
    orderList,
    period: SEARCH_PERIOD,
  };
  /**!SECTION - Props */

  /**
   * SECTION - Render
   */
  return (
    <React.Fragment>
      <ShopSalesDashboardPresenter {...PROPS} />
    </React.Fragment>
  );
  /**!SECTION - Render */
};

export default ShopSalesDashboardContainer;
